import React, { useState } from "react";
import "./Tracker.css"
import axios from "axios";

function Tracker() {
  const [trackingId, setTrackingId] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const trackParcel = async () => {
    setLoading(true);
    setError("");
    setResult("");

    try {
      const response = await axios.post("http://localhost:3001/track", { trackingId });
      setResult(response.data.trackingData);
    } catch (err) {
      setError("Tracking failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="tracker-container">
      <h1 className="tracker-heading">Track Your Shipment</h1>
      <p className="track-suggestion">Enter any combination of tracking Reference number.</p>
      <div className="tracker-input-field">
        {/* <i class="ri-guide-line" /> */}
        <input
          type="text"
          value={trackingId}
          onChange={(e) => setTrackingId(e.target.value)}
          placeholder="Enter Tracking Number"
          required
        />
        <button onClick={trackParcel} disabled={loading}>
          {loading ? "Tracking..." : "Track Shipment"}
        </button>
      </div>
        
      {error && <p className="track-error" >{error}</p>}

      <div className="tracking-result" >
        <h3 className="tracking-result-heading">Shipment Result</h3>
      {result && (
        <div style={{ marginTop: "20px", border: "1px solid black", padding: "10px" }}>
          <h3>Tracking Result:</h3>
          <p>{result}</p>
        </div>
      )}
      </div>
    </div>
  );
}

export default Tracker;
